var module = angular.module('main.resellerorder');

module.component('caResellerOrderScannerNavigation',{
    templateUrl: 'main/resellerorder/genericcomponents/scannernavigation.cmp.tpl.html',
    bindings: {
        initCollapsed: '<',
        initFocused: '<',
        navigateToStateName: '<'
    },
    controllerAs: 'vm',
    controller: ['$translate', '$state', 'ToasterService', 'ResellerOrdersApiService', 'loadSpinnerService', componentController]
});

function componentController($translate, $state, ToasterService, ResellerOrdersApiService, loadSpinnerService) {
    var vm = this;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.submitScannerInput = submitScannerInput;

    vm.scannerInput = "";

    vm.collapseHeader = vm.initCollapsed ? vm.initCollapsed : true;

    function onInit() {
        if (vm.initFocused) {
            angular.element("#resellerOrderScannerNavigationField").focus();
        }

        $("#resellerOrderScannerNavigationField").keydown(function(e) {
            var enterKeyCode = 13;
            if (e !== undefined && e.keyCode === enterKeyCode) {
                submitScannerInput();
            }
        });
    }

    function onChanges(changes) {

    }

    function submitScannerInput() {
        console.log("Scanned the following: ", vm.scannerInput);
        var orderNumber = vm.scannerInput.split(':')[0];
        var productNumber = vm.scannerInput.split(':')[1];

        var stateName = vm.navigateToStateName;

        loadSpinnerService.start('mainSpinner');
        ResellerOrdersApiService.getResellerOrderByOrderNumber(orderNumber).then(function(response) {
            var orderId = response.id;
            $state.go(stateName, {
                orderId: orderId,
                productNumber: productNumber,
                usingScannerNavigation: true
            });
        }, function(error) {
            ToasterService.showError(error);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner', { force: true });
        });


    }
}